import { observable, /**action ,*/ makeObservable /**computed*/ } from "mobx";
import axios from "axios";
import { serverUrl } from ".";

export interface Resource {
  id: string;
  name: string;
  description: string;
  files: Array<{
    id: string;
    name: string;
    link: string;
  }>;
}

export interface ResFile {
  id: string;
  name: string;
  description: string;
  link: string;
}

export class ResourcesStore {
  resources: Resource[] = [];
  files: ResFile[] = [];

  constructor() {
    makeObservable(this, {
      resources: observable,
      files: observable,
    });
  }

  getResources = async () => {
    try {
      const response = await axios.get(`${serverUrl}/resources`);
      this.resources = response.data || [];
    } catch (err) {
      console.error("ResourcesStore.ts => getResources:", err);
    }
  };

  getFiles = async () => {
    try {
      const response = await axios.get(`${serverUrl}/files`);
      this.files = response.data || [];
    } catch (err) {
      console.error("ResourcesStore.ts => getFiles:", err);
    }
  };

  trackDownload = async ({ sessionId }: { sessionId: string }) => {
    try {
      await axios.post(`${serverUrl}/metrics/track-download`, { sessionId });
    } catch (err) {
      console.error("ResourcesStore.ts => trackDownload:", err);
    }
  };
}

const resourcesStore = new ResourcesStore();

export default resourcesStore;
